import { render } from "./TemplateBuilder.vue?vue&type=template&id=ccfe3126"
import script from "./TemplateBuilder.vue?vue&type=script&lang=js"
export * from "./TemplateBuilder.vue?vue&type=script&lang=js"

import "./shared/styles/index.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__